var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellular1Bars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 53,
    viewBox: "0 0 71 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63949 26H2.36052C1.05684 26 0 27.0336 0 28.3087V50.6913C0 51.9664 1.05684 53 2.36052 53H8.63949C9.94316 53 11 51.9664 11 50.6913V28.3087C11 27.0336 9.94316 26 8.63949 26Z",
    fill: "#6AA442"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3605 1H68.6395C69.0132 1 69.3638 1.14289 69.6161 1.38509C69.867 1.62595 70 1.94369 70 2.26593V50.7341C70 51.0563 69.867 51.374 69.6161 51.6149C69.3638 51.8571 69.0132 52 68.6395 52H62.3605C61.9868 52 61.6362 51.8571 61.3839 51.6149C61.133 51.3741 61 51.0563 61 50.7341V2.26593C61 1.94368 61.133 1.62594 61.3839 1.38509C61.6362 1.1429 61.9868 1 62.3605 1Z",
    stroke: "#838B98",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3605 8H53.6395C54.0157 8 54.3672 8.14276 54.619 8.38254C54.8692 8.62074 55 8.93305 55 9.24774V50.7523C55 51.0669 54.8692 51.3793 54.619 51.6175C54.3672 51.8572 54.0157 52 53.6395 52H47.3605C46.9843 52 46.6328 51.8572 46.381 51.6175C46.1308 51.3793 46 51.0669 46 50.7523V9.24774C46 8.93305 46.1308 8.62074 46.381 8.38254C46.6328 8.14276 46.9843 8 47.3605 8Z",
    stroke: "#838B98",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3605 14H38.6395C39.4237 14 40 14.6055 40 15.2805V50.7195C40 51.3945 39.4237 52 38.6395 52H32.3605C31.5763 52 31 51.3945 31 50.7195V15.2805C31 14.6055 31.5763 14 32.3605 14Z",
    stroke: "#838B98",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3605 21H23.6395C24.4335 21 25 21.6046 25 22.2572V50.7428C25 51.3954 24.4335 52 23.6395 52H17.3605C16.5665 52 16 51.3954 16 50.7428V22.2572C16 21.6046 16.5665 21 17.3605 21Z",
    stroke: "#838B98",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellular1Bars);
export default __webpack_public_path__ + "static/media/cellular-1-bars.44570ad110208d9a7acde741a5f0bc39.svg";
export { ForwardRef as ReactComponent };